import * as actionTypes from './actions';
export const initialState = {
  success: false,
  loading: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DETAIL:
      return {
        ...state,
      };
      case actionTypes.LOGIN_SUCCESS: {
        return {
          ...state,
          success: true,
          loading: false,
          payload: action
        };
      }
    default:
      return state;
  }
};

export default userReducer;
